module.exports = __webpack_public_path__ + "static/images/containers/MainMenu/images/mainmenu-item-craft-64.15f68c5b.png";


//////////////////
// WEBPACK FOOTER
// ./containers/MainMenu/images/mainmenu-item-craft-64.png
// module id = 3195
// module chunks = 11